window.requestAnimationFrame = window.requestAnimationFrame ||
  window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame ||
  window.msRequestAnimationFrame || (cb, el) -> window.setTimeout(cb, 1000 / 60)

window.cancelAnimationFrame = window.cancelAnimationFrame ||
  window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame ||
  window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame ||
  clearTimeout
